import React, { useMemo } from 'react';
import { object } from 'prop-types';
import moment from 'moment';
import { TableCustom } from '../../common';
import { GetFieldMes } from '../../../utils/helpers';
import { getDateToString } from '../../../utils/convert';
import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';
import { useEntidad } from '../../hooks/useEntidad';
import { PERIODICIDAD_DECLARACION_JURADA } from '../../../consts/periodicidadDeclaracionJurada';
import './index.scss';

const DeclaracionesJuradasPendientesGrid = (props) => {

  const [, getRowEntidad] = useEntidad({
    entidades: ['ModeloDeclaracionJurada'],
    onLoaded: (entidades, isSuccess, error) => {
      if (!isSuccess) {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'ModeloDeclaracionJurada',
      timeout: 0
    }
  });

  const getDescModeloDeclaracionJurada = (id) => {
    const row = getRowEntidad('ModeloDeclaracionJurada', id);
    return (row) ? row.nombre : '';
  }

  const cellPeriodo = (data) => {
    const declaracion = data.row.original;
    const modelo = getRowEntidad('ModeloDeclaracionJurada', declaracion.idModeloDeclaracionJurada);
    const periodo = {
      [PERIODICIDAD_DECLARACION_JURADA.BIMESTRAL]: 'Bimestre',
      [PERIODICIDAD_DECLARACION_JURADA.TRIMESTRAL]: 'Trimestre',
      [PERIODICIDAD_DECLARACION_JURADA.SEMESTRAL]: 'Semestre'
    }[modelo?.idPeriodicidadDeclaracionJurada];
    return (periodo) ? `${declaracion.mesDeclaracion}° ${periodo} ${declaracion.anioDeclaracion}` : data.value;
  }

  const listTable = useMemo(() => {
    const list = props.data.list.map(row => {
      const mes = GetFieldMes(row.mesDeclaracion, 'cuota');
      return {
        ...row,
        periodoDeclaracion: (mes) ? `${mes}/${row.anioDeclaracion}` : `${row.anioDeclaracion}`
      };
    });
    list.sort((a, b) =>
      moment(a.fechaVencimientoDeclaracionJurada).diff(moment(b.fechaVencimientoDeclaracionJurada)) ||
      a.periodoDeclaracion.localeCompare(b.periodoDeclaracion)
    );
    return list;
  }, [props.data.list]);

  const resumen = useMemo(() => {
    const noPresentadas = listTable.filter(f => !f.enTermino).length;
    const enPlazo = listTable.length - noPresentadas;
    const partes = [];
    if (noPresentadas > 0) partes.push(`${noPresentadas} no ${(noPresentadas === 1) ? 'presentada' : 'presentadas'}`);
    if (enPlazo > 0) partes.push(`${enPlazo} ${(enPlazo === 1) ? 'pendiente' : 'pendientes'}, todavía en plazo`);
    return partes.join(' · ');
  }, [listTable]);

  const cellEstado = (data) => (data.value)
    ? <span className="estado-chip estado-chip--neutro">Pendiente</span>
    : <span className="estado-chip estado-chip--error">No presentada</span>

  const tableColumns = [
    { Header: 'Declaración jurada', Cell: (data) => getDescModeloDeclaracionJurada(data.value), accessor: 'idModeloDeclaracionJurada', width: '46%' },
    { Header: 'Período', Cell: cellPeriodo, accessor: 'periodoDeclaracion', width: '18%' },
    { Header: 'Vencimiento', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaVencimientoDeclaracionJurada', width: '18%' },
    { Header: 'Estado', Cell: cellEstado, accessor: 'enTermino', width: '18%' }
  ];

  return (
    <TableCustom
      showFilterGlobal={false}
      className={'TableCustomBase'}
      columns={tableColumns}
      data={listTable}
      controlSlot={(resumen) ? <div className='align-self-center py-2'>{resumen}</div> : null}
      messageEmpty='No hay períodos pendientes de presentación para esta cuenta'
    />
  );
}

DeclaracionesJuradasPendientesGrid.propTypes = {
  data: object.isRequired,
};

export default DeclaracionesJuradasPendientesGrid;
